
import React from 'react';
import { format } from 'date-fns';

interface ChartTitleProps {
  userWord: string;
  date: string;
  roundsLength: number;
  width: number;
  textStartY: number;
  textLine2Y: number;
  titleFontSize: number;
  subtitleFontSize: number;
}

export const ChartTitle: React.FC<ChartTitleProps> = ({ 
  userWord, 
  date, 
  roundsLength, 
  width, 
  textStartY, 
  textLine2Y,
  titleFontSize,
  subtitleFontSize
}) => {
  // Format the date string properly
  let formattedDate = "";
  let roundsText = `${roundsLength} rounds`;
  
  try {
    // Try to parse and format the date
    const dateObj = new Date(date);
    formattedDate = format(dateObj, 'MMM d');
  } catch (e) {
    console.error("Error formatting date:", e);
    formattedDate = "Unknown date";
  }

  // Create combined date and rounds text
  const dateAndRoundsText = `${formattedDate} | ${roundsText}`;
  
  // Capitalize first letter of the word
  const capitalizeFirstLetter = (str: string) => {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };
  
  const userWordCapitalized = capitalizeFirstLetter(userWord);
  
  // Create the formatted title with quotes
  const titleText = `"${userWordCapitalized}"`;

  return (
    <>
      <text 
        x={width/2} 
        y={textStartY} 
        fill="#FFFFFF" 
        data-fill-variable="--foreground"
        fontSize={titleFontSize}
        fontWeight="bold" 
        textAnchor="middle"
        fontFamily="'Inter', 'Helvetica', 'Arial', sans-serif"
      >
        {titleText}
      </text>
      <text 
        x={width/2} 
        y={textLine2Y} 
        fill="#FFFFFF" 
        data-fill-variable="--foreground"
        fontSize={subtitleFontSize}
        textAnchor="middle"
        fontFamily="'Inter', 'Helvetica', 'Arial', sans-serif"
      >
        {dateAndRoundsText}
      </text>
    </>
  );
};
